import itiriri from 'itiriri';
import { makeAutoObservable, toJS } from 'mobx';
import { computedFn, expr } from 'mobx-utils';
import {
  BehaviorSubject,
  Subject,
} from 'rxjs';

import { CowStanzonePushTypeT } from '^/__generated__/pothosZod/generated_enums';
import { asSuccessPromise, FreshnessType, getCurrentFreshness } from '^/types/__ResultType';
import { CameraIDType } from '^/types/cameraTypes';
import { computedFn2 } from '^/utils/mobx-utils/mobxComputedFn2';

import { APIClient } from '../apiClient';
import { createAutoSyncedCaller3 } from '../autoSyncedCore/autoSyncedCaller3';
import { TokenRepo } from '../repositories/TokenRepo';

// eslint-disable-next-line @typescript-eslint/naming-convention
type __SERIALIZED_CowStanzonesListFilter = string & {
  __SERIALIZED_CowStanzonesListFilterTyp: null;
};

export type CowStanzonesListFilterType = {
  cameraId?: CameraIDType,
  after?: Date,
  pushTypes?: CowStanzonePushTypeT[],
  take?: number,
};
function serializeCowStanzonesListFilter(
  filter: CowStanzonesListFilterType,
) {
  // TODO: filter/sort options?
  return JSON.stringify(filter) as __SERIALIZED_CowStanzonesListFilter;
}

export class CowStanzoneListCore {
  constructor(
    public apiClient: APIClient,
    public tokenRepo: TokenRepo,
    public refreshTrigger: Subject<
      FreshnessType
    > = new BehaviorSubject(
      getCurrentFreshness(),
    ),
  ) {
    makeAutoObservable(this, {
      apiClient: false,
      refreshTrigger: false,
    });
  }

  private fetchStanzonesList = computedFn2((
    filter: CowStanzonesListFilterType,
  ) => {
    const userTokenResult = this
      .tokenRepo
      .userToken;
    if (userTokenResult.status !== 'success') {
      return userTokenResult;
    }

    const aa = expr(() => createAutoSyncedCaller3(
      this
        .apiClient
        .stanzone
        .getCowStanzoneRawReports
        .mutate,
      {
        userToken: userTokenResult.value,
        searchAfter: filter.after,
        pushType: filter.pushTypes,
        take: filter.take,
      },
      this.refreshTrigger,
    ));
    return asSuccessPromise(aa);
  });

  getStanzone = computedFn((
    filter: CowStanzonesListFilterType,
  ) => {
    const result = this
      .fetchStanzonesList(filter);

    if (result.status !== 'success') {
      return result;
    }
    const v = result
      .value
      .current()
      .value
      .value;
    console.log('[CowStanzoneListCore getStanzone v:', toJS(v));
    return v;
  });

  getStanzoneHistoryByCamId = computedFn((
    filter: CowStanzonesListFilterType,
  ) => {
    const stanzonesResult = this
      .getStanzone(filter);
    if (stanzonesResult.status !== 'success') {
      return stanzonesResult;
    }
    const stanzones = itiriri(stanzonesResult.value);
    const stanzonesByCamId = stanzones
      .groupBy(
        (s) => s.cameraId as CameraIDType,
        // (v) => {

        // },
      )
      .toMap(
        (k) => k[0],
        (v) => v[1],
      );

    return asSuccessPromise(stanzonesByCamId);
  });

  private fetchStanzonesPushList = computedFn2((
    filter: CowStanzonesListFilterType,
  ) => {
    const userTokenResult = this
      .tokenRepo
      .userToken;
    if (userTokenResult.status !== 'success') {
      return userTokenResult;
    }

    const aa = expr(() => createAutoSyncedCaller3(
      this
        .apiClient
        .stanzone
        .getCowStanzoneRawReports
        .mutate,
      {
        userToken: userTokenResult.value,
        searchAfter: filter.after,
      },
      this.refreshTrigger,
    ));
    return asSuccessPromise(aa);
  });

  getStanzonePushNotifications = computedFn((
    filter: CowStanzonesListFilterType,
  ) => {
    const result = this
      .fetchStanzonesPushList(filter);

    if (result.status !== 'success') {
      return result;
    }
    const v = result
      .value
      .current()
      .value
      .value;
    console.log('[CowStanzoneListCore getStanzone v:', toJS(v));
    return v;
  });
}
